/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	ActionIcon,
	RingProgress,
	Text,
	Center,
	rem,
} from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { MintStatus } from '@config/constants/mint-status';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */
type TRingProgressIndicatorProps = {
	verified: boolean;
	progress: string;
	status: string;
	destroy:
		| {
				by: string;
				status: string;
				reason: string;
				transactionHash: string;
				updatedAt: string;
		  }
		| undefined;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const RingProgressIndicator = ({
	verified,
	progress,
	status,
	destroy,
}: TRingProgressIndicatorProps) => {
	const commonProps = { size: 60, thickness: 6 };

	if (destroy && destroy.status === 'SUCCESS') {
		return (
			<RingProgress
				{...commonProps}
				sections={[{ value: 100, color: '#F6635A' }]}
				label={
					<Center>
						<ActionIcon
							color="#F6635A"
							variant="light"
							radius="xl"
							size="xl"
						>
							<IconX
								style={{
									width: rem(22),
									height: rem(22),
								}}
							/>
						</ActionIcon>
					</Center>
				}
			/>
		);
	}

	if (destroy && destroy.status !== 'SUCCESS') {
		return (
			<RingProgress
				{...commonProps}
				sections={[{ value: 100, color: '#32BA7C' }]}
				label={
					<Center>
						<ActionIcon
							color="#32BA7C"
							variant="light"
							radius="xl"
							size="xl"
						>
							<IconCheck
								style={{
									width: rem(22),
									height: rem(22),
								}}
							/>
						</ActionIcon>
					</Center>
				}
			/>
		);
	}

	if (status === MintStatus.ERROR) {
		return (
			<RingProgress
				{...commonProps}
				sections={[{ value: 100, color: '#F6635A' }]}
				label={
					<Text
						c="#F6635A"
						fw={700}
						ta="center"
						size="xs"
					>
						{progress}%
					</Text>
				}
			/>
		);
	}

	if (verified || progress.toString() === '100') {
		return (
			<RingProgress
				{...commonProps}
				sections={[{ value: 100, color: '#32BA7C' }]}
				label={
					<Center>
						<ActionIcon
							color="#32BA7C"
							variant="light"
							radius="xl"
							size="xl"
						>
							<IconCheck
								style={{
									width: rem(22),
									height: rem(22),
								}}
							/>
						</ActionIcon>
					</Center>
				}
			/>
		);
	}

	return (
		<RingProgress
			{...commonProps}
			sections={[
				{ value: Number(progress), color: '#FF9D42' },
			]}
			label={
				<Text
					c={'#FF9D42'}
					fw={700}
					ta="center"
					size="xs"
				>
					{progress}%
				</Text>
			}
		/>
	);
};
